<p-dialog
  header="Gestion des étiquettes"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '550px' }"
  (onHide)="onDialogHide()"
>
  <!-- Create new label -->
  <div class="flex items-center gap-2 mb-4">
    <input
      type="text"
      pInputText
      [(ngModel)]="newLabelText"
      placeholder="Nouvelle étiquette..."
      class="flex-1"
      (keydown.enter)="createLabel()"
    />
    <button
      pButton
      icon="pi pi-plus"
      label="Ajouter"
      [disabled]="!newLabelText.trim() || saving"
      (click)="createLabel()"
    ></button>
  </div>

  <!-- Labels list -->
  <div *ngIf="loading" class="flex justify-center p-4">
    <p-progressSpinner
      [style]="{ width: '40px', height: '40px' }"
    ></p-progressSpinner>
  </div>

  <div *ngIf="!loading && labels.length === 0" class="text-center p-4">
    <p class="text-gray-500">Aucune étiquette pour ce poste de travail.</p>
  </div>

  <!-- Scrollable labels container -->
  <div
    *ngIf="!loading && labels.length > 0"
    class="overflow-y-auto"
    style="max-height: 400px"
  >
    <div class="flex flex-col gap-2">
      <div
        *ngFor="let label of labels"
        class="flex items-center justify-between p-2 border rounded border-gray-200 dark:border-gray-700"
      >
        <!-- View mode -->
        <ng-container *ngIf="editingLabel?.uid !== label.uid">
          <span class="flex-1">{{ label.label }}</span>
          <div class="flex gap-1">
            <button
              pButton
              icon="pi pi-pencil"
              class="p-button-text p-button-sm"
              (click)="startEdit(label)"
              [disabled]="saving"
            ></button>
            <button
              pButton
              icon="pi pi-trash"
              class="p-button-text p-button-danger p-button-sm"
              (click)="confirmDelete(label)"
              [disabled]="saving"
            ></button>
          </div>
        </ng-container>

        <!-- Edit mode -->
        <ng-container *ngIf="editingLabel?.uid === label.uid">
          <input
            type="text"
            pInputText
            [(ngModel)]="editLabelText"
            class="flex-1 mr-2"
            (keydown.enter)="saveEdit()"
            (keydown.escape)="cancelEdit()"
          />
          <div class="flex gap-1">
            <button
              pButton
              icon="pi pi-check"
              class="p-button-text p-button-success p-button-sm"
              (click)="saveEdit()"
              [disabled]="!editLabelText.trim() || saving"
            ></button>
            <button
              pButton
              icon="pi pi-times"
              class="p-button-text p-button-sm"
              (click)="cancelEdit()"
            ></button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
